export const TOUR_COMPARE_SUCCESS = "TOUR_COMPARE_SUCCESS";
export const TOUR_COMPARE_ERROR = "TOUR_COMPARE_ERROR";
export const TOUR_COMPARE_START = "TOUR_COMPARE_START";